import { useAuth } from '@clerk/nextjs';
import axios from 'axios';
import React from 'react';

function ClerkTokenInjector() {
  const { getToken, isSignedIn } = useAuth();

  React.useEffect(() => {
    // This is useless condition as "ClerkTokenInjector" will never be called when user is not signed in,
    // Still happy to have a extra layer of check
    if (!isSignedIn) return;

    // Listens to all requests and adds the token to the header
    // TODO - call interceptors.eject to remove the interceptor - MUST
    const authorizationInterceptor = axios.interceptors.request.use(
      async function (config) {
        // Do something before request is sent
        config.headers.Authorization = `Bearer ${await getToken()}`;
        config.headers['x-deployment-id'] = process.env.VERCEL_DEPLOYMENT_ID;
        return config;
      },
      function (error: any) {
        // Do something with request error
        return Promise.reject(error);
      },
    );

    return () => {
      // Ejects the interceptor
      axios.interceptors.request.eject(authorizationInterceptor);
    };
  }, [isSignedIn, getToken]);

  return null;
}

export { ClerkTokenInjector };
